/**
 * @type {String}
 */
export const TASK_DROPDOWN_LIST_CLASS_NAME = 'task-dropdown-list';

export const TASK_DROPDOWN_LIST_HORIZONTAL_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const TASK_DROPDOWN_LIST_VERTICAL_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
};
